module.exports = __webpack_public_path__ + "static/img/ringone_icon.4eb267e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/ringone_icon.jpg
// module id = /tMN
// module chunks = 1